import { useLocation } from "react-router-dom";

/**
 * Verifica si la URL actual comienza con "/en/"
 * @returns {boolean}
 */
export const useIsEnglishUrl = () => {
    const location = useLocation();
    const isEnglish = location.pathname.startsWith("/en/");
    return isEnglish;

}